import { LOCALE } from 'utils';

export function rewriteFinesioUrl(
  url: string | undefined | null,
  locale: string
): string | undefined {
  const cleanedUrl = url
    ?.replace('https://images.finesio-tech.com', '')
    .replace('https://finesio.b-cdn.net', '');

  if (cleanedUrl?.startsWith('/')) {
    let baseImageHost = null;
    const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;

    switch (environment) {
      case 'development':
      case 'local':
      case 'staging':
        baseImageHost = `finesio.b-cdn.net`;
        break;

      case 'production':
        const localeToHostMap = {
          [LOCALE.PL]: 'finesio.b-cdn.net',
          [LOCALE.SK]: 'finesio.b-cdn.net',
          [LOCALE.CZ]: 'finesio.b-cdn.net',
          [LOCALE.RO]: 'finesio.b-cdn.net',
          [LOCALE.DE]: 'finesio.b-cdn.net',
        };

        baseImageHost =
          localeToHostMap[locale as keyof typeof localeToHostMap] || null;
        break;

      default:
        throw new Error(`Unknown environment: ${environment}`);
    }

    if (baseImageHost) {
      return `https://${baseImageHost}${cleanedUrl}`;
    }
  }

  return url || undefined;
}
